/*
* Molecules are made up of two or more atoms
* The first letter of name of function should be in capital letter
* @Author STRUCTLOOPER
* */
import React from "react";
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import _ from "lodash"
import {repoButton} from "../../uitls/primaryStyles";
export function HeaderAndFooterCard({repo,clone,star,fork}) {
    return (
        <div className="col-lg-6 col-md-6 icon-box" data-aos="fade-up">
        <Card className="text-end" style={{ height:"100%" }}>
           <Card.Body>
                <Card.Text>
                    <div className="row">
                        <img src={`https://opengraph.githubassets.com/e66de8ec94c683da9d8667581a6f17ad4a4898a9694f82defce0b1301b201284/${repo}`}
                        style={{ width:'120%', height:'120%', resize:'cover' }}
                        />
                    </div>
                </Card.Text>
            </Card.Body>
            <Card.Footer className="text-muted text-start ">
                <div className="row">

                    <div className="col-md-4 text-start">
                        {!_.isUndefined(star) &&  <Button variant="warning"  size="sm" style={repoButton}>
                            <i className="bi bi-star" />
                             &nbsp;Star</Button> }
                        {!_.isUndefined(fork) && <Button variant="info" size="sm" style={repoButton}>
                            <i className="bi bi-archive"/>
                            &nbsp;Fork</Button>}
                    </div>
                    <div className="col-md-8 text-end">
                        {!_.isUndefined(clone) && <Button variant="outline-dark" size="md" style={repoButton}>
                            <i className="bi bi-files" />
                            &nbsp;Clone &nbsp;</Button> }
                        {!_.isUndefined(repo) && <Button href={`https://github.com/${repo}`} target="_blank" variant="outline-secondary" size="md" style={repoButton}>
                            <i className="bi bi-code" />
                            &nbsp;View Repository</Button>}

                    </div>
                </div>

            </Card.Footer>
        </Card>
        </div>
    );
}

